<template>
  <div class="app mt-4">
    <v-sheet v-show="showSkeletonForm" class="pa-3">
      <v-row>
        <v-col v-for="n in 4" :key="`line_form_2_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer v-for="p in 10" :key="`spacer_${p}`" />
        <v-col>
          <v-skeleton-loader type="button" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form v-show="!showSkeletonForm">
      <v-row dense>
        <v-col cols="3">
          <v-datetime-picker
            label="Data início"
            v-model="datetimestart"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col cols="3">
          <v-datetime-picker
            label="Data fim"
            v-model="datetimeend"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>

            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>

            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col cols="3">
          <v-select 
          dense 
          outlined 
          multiple 
          label="Pesquisas" 
          :items="pesquisas" 
          v-model="form.pesquisas"
          :error-messages="pesquisasErrors"
          @input="$v.form.pesquisas.$touch()"
          @blur="$v.form.pesquisas.$touch()"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.pesquisas.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="togglePesquisas">
                <v-list-item-action>
                  <v-icon :color="form.pesquisas.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconPesquisas }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>

        <v-col cols="3">
          <v-select dense outlined multiple label="TAGs" v-model="form.tags" :items="tags">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.tags.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleTags">
                <v-list-item-action>
                  <v-icon :color="form.tags.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconTags }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-right">
          <v-btn dark color="bluePcm" @click="gerarRelatorioResumido">Gerar</v-btn>
        </v-col>
      </v-row>

      <!-- {{form.pesquisas}} -->

      <v-divider class="ma-2" />

      <v-sheet v-show="showSkeletonReport" class="pa-3">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>

      <div v-if="canShowReport && !showSkeletonReport">
        <ExpansionList :avaliacoes="dadosRelatorio" />
      </div>
      <!-- {{dadosRelatorio}} -->
    </v-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import { initialAndFinalDateTextInputReportForm } from '@/mixins/initialAndFinalDateTextInputReportForm'

import { relatoriosPesquisaSatisfacaoMixins } from '../../../mixins/relatoriosPesquisaSatisfacaoMixins'
import relatorioResumidoPesquisaSatisfacaoStore from '../_store'

import ExpansionList from '../_components/ExpansionList'
import { validateData, validateComputed } from '../_validates'

export default {
  components: { ExpansionList },
  mixins: [initialAndFinalDateTextInputReportForm, relatoriosPesquisaSatisfacaoMixins],
  data: () => ({
    form: {
      dataHoraInicio: '',
      dataHoraFim: '',
      pesquisas: [],
      tags: [],
    },
    dadosRelatorio: [],
  }),
  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('relatorioResumidoPesquisaSatisfacaoStore', ['getDadosRelatorio']),
  },

  async created() {
    this.showSkeletonForm = true
    registerVuexModule(
      this.$store,
      'relatorioResumidoPesquisaSatisfacaoStore',
      relatorioResumidoPesquisaSatisfacaoStore
    )

    await Promise.all([this.listarPesquisasSatisfacao(), this.listarTags()])
    this.pesquisas = this.getPesquisasSatisfacao.map(pesquisa => ({ text: pesquisa.description, value: pesquisa._id }))
    this.tags = this.getTags.map(tag => ({ text: tag.description, value: tag._id }))
    // this.tags.sort(function(a, b){
    //     if(a.text.toLowerCase() < b.text.toLowerCase()) { return -1; }
    //     if(a.text.toLowerCase() > b.text.toLowerCase()) { return 1; }
    //     return 0;
    // })
    

    this.showSkeletonForm = false
  },

  methods: {
    ...mapActions('relatorioResumidoPesquisaSatisfacaoStore', ['gerarRelatorio']),

    async gerarRelatorioResumido() {
       this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        return
      }

      this.showSkeletonReport = true

      this.form.dataHoraInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm')
      this.form.dataHoraFim = moment(this.datetimeend).format('YYYY-MM-DD HH:mm')

      await this.gerarRelatorio(this.form)
      this.dadosRelatorio = [...this.getDadosRelatorio]
      this.showSkeletonReport = false
      this.canShowReport = true

    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
